import { render, staticRenderFns } from "./CoursePage.vue?vue&type=template&id=a1235a90&"
import script from "./CoursePage.vue?vue&type=script&lang=js&"
export * from "./CoursePage.vue?vue&type=script&lang=js&"
import style0 from "./CoursePage.vue?vue&type=style&index=0&id=a1235a90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports